// import { images } from '@/asset';
import { PATH } from '@/constants';
// import customersList from '@/constants/customerHidePayment';
import userPlans from '@/hooks/userPlans';
// import { apiCaller } from '@/redux/query';
// import bannerSlice, { bannerSelector } from '@/redux/slice/banner.slice';
import { dataSettingsSelector } from '@/redux/slice/dataSettings.slice';
import { handleShowModalSearch, showModalSearchSelector } from '@/redux/slice/home.slice';
import { ILayout } from '@/types/components';
import { Button, ButtonGroup, Link, Page } from '@shopify/polaris';
import { ChartVerticalFilledIcon, PlanFilledIcon, SettingsIcon, ShieldCheckMarkIcon, WrenchIcon } from '@shopify/polaris-icons';
import { memo, useEffect, useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEventListener } from 'usehooks-ts';
import ModalSearch from '../ModalSearch';
import RegularText from '../RegularText';
import { LayoutStyled } from './styled';
// import { TFunction } from 'i18next';

const btnGroup = [
  {
    content: 'Home',
    icon: ShieldCheckMarkIcon,
    path: PATH.DEFAULT,
  },
  {
    content: 'Visitor Analytics',
    icon: ChartVerticalFilledIcon,
    path: PATH.ANALYTICS,
  },
  {
    content: 'Blocker & Re-director ',
    icon: WrenchIcon,
    path: PATH.BLOCKLIST,
  },
  // {
  //   content: 'Fraud orders analytics',
  //   icon: WrenchIcon,
  //   path: PATH.FRAUD_ORDER,
  // },
  // {
  //   content: 'Block checkout',
  //   icon: WrenchIcon,
  //   path: PATH.BLOCKED_CHECKOUT,
  // },
  // customersList.includes(config.shop)
  //   ? {
  //       content: 'Checkout rules',
  //       icon: WrenchIcon,
  //       path: PATH.CHECKOUT_RULES,
  //     }
  //   : undefined,
  {
    content: 'Settings',
    icon: SettingsIcon,
    path: PATH.SETTINGS,
  },
  {
    content: 'Pricing',
    icon: PlanFilledIcon,
    path: PATH.PRICING_PLAN,
  },
  {
    content: 'Development',
    icon: PlanFilledIcon,
    path: PATH.CONTACT_TO_USE_DEVELOPMENT_STORE,
    hide: true,
  },
];

const Layout = ({ children, layoutProps, isVisibleHeader = true, ...props }: ILayout.IProps): JSX.Element => {
  const location = useLocation();
  const navigate = useNavigate();
  const { userPlanFree } = userPlans();
  const { t } = useTranslation('dashboard');
  const showModalSearch = useSelector(showModalSearchSelector);
  const dataSettings = useSelector(dataSettingsSelector);
  const isDevPlan = dataSettings && dataSettings?.settings?.isShowDevelopmentPlanPage;
  const searchParams = new URLSearchParams(location.search);
  const isAdminHost = searchParams.get('embedded') === 'false';
  const isUrlLocalhost = window.location.hostname === 'localhost';

  const isShowListBtn = isVisibleHeader && (isUrlLocalhost || isAdminHost);

  const dispatch = useDispatch();
  useLayoutEffect(() => {
    if (userPlanFree && isDevPlan) {
      navigate(PATH.CONTACT_TO_USE_DEVELOPMENT_STORE);
    }
  }, [isDevPlan, userPlanFree, navigate]);

  useLayoutEffect(() => {
    if (location.pathname === PATH.CONTACT_TO_USE_DEVELOPMENT_STORE.pathname && !isDevPlan) {
      navigate(PATH.DEFAULT);
    }
  }, [location.pathname, navigate, isDevPlan]);

  useEffect(() => {
    if (dataSettings && dataSettings.settings) {
      if (userPlanFree && isDevPlan) {
        navigate(PATH.CONTACT_TO_USE_DEVELOPMENT_STORE);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(dataSettings)]);

  useEventListener('keydown', (event: KeyboardEvent) => {
    if (event.ctrlKey && event.shiftKey && event.key === 'F') {
      dispatch(handleShowModalSearch(true));
    }
  });

  const getDocumentationLink = () => {
    if (location.pathname === PATH.FRAUD_ORDER.pathname) {
      return 'https://help.omegatheme.com/en/article/fraud-orders-20viht/';
    } else if (location.pathname === PATH.BLOCKED_CHECKOUT.pathname) {
      return 'https://help.omegatheme.com/en/article/block-checkout-based-on-conditions-1xu6630/';
    } else {
      return 'https://help.omegatheme.com/en/category/blockify-fraud-ip-blocker-1l09cxw/';
    }
  };

  return (
    <LayoutStyled isFullWidth={props.isFullWidth} id="blockify-layout">
      {isShowListBtn ? (
        <div className="nav-bar">
          <ButtonGroup fullWidth gap="extraTight">
            {btnGroup
              .filter((item) => item !== undefined)
              .filter((item) => item?.hide !== true)
              .filter((item) => item?.path !== PATH.HIDE_PAYMENT)
              .map((item, index) => {
                return (
                  <Button
                    key={index}
                    icon={item?.icon}
                    variant={
                      location.pathname === item?.path.pathname || (index === 0 && location.pathname === '/')
                        ? 'primary'
                        : undefined
                    }
                    onClick={() => {
                      navigate({
                        ...item?.path,
                      });
                    }}
                  >
                    {item?.content}
                  </Button>
                );
              })}
          </ButtonGroup>
        </div>
      ) : null}

      <Page {...layoutProps}>
        <div>{children}</div>
        <RegularText>
          <div className="layout-footer">
            {t('common:need_help_view')}&nbsp;
            <Link removeUnderline external url={getDocumentationLink()}>
              {t('common:documentation_guide')}
            </Link>
          </div>
        </RegularText>
      </Page>

      {showModalSearch ? <ModalSearch /> : null}
    </LayoutStyled>
  );
};

export default memo(Layout);
